/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ClassroomPages,
  ClassroomScreenCard,
  ClassroomScreenCardInput,
  ClassroomScreenInput,
  ClassroomScreenPage,
  ClassroomScreenPageInput,
  ClassroomScreenScreen,
  GetClassroomScreenParams,
  ListClassroomScreensParams,
  PaginatedClassroomScreens,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Duplicate Card
 */
export const duplicateCard = (
    cardId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      cardId = toValue(cardId);

      return axiosClient<ClassroomScreenCard>(
      {url: `/teaching_board/cards/${cardId}/duplicate`, method: 'PATCH', signal
    },
      );
    }




export const getDuplicateCardMutationKey = () => ['duplicateCard'] as const;

export const getDuplicateCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,DuplicateCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,DuplicateCardMutationVariables, TContext> => {

const mutationKey = getDuplicateCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateCard>>, DuplicateCardMutationVariables> = (props) => {
          const {cardId} = props ?? {};

          return  duplicateCard(cardId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateCardMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateCard>>>

    export type DuplicateCardMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DuplicateCardMutationVariables = {cardId: string}

    /**
 * @summary Duplicate Card
 */
export const useDuplicateCard = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,DuplicateCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateCard>>,
        TError,
        DuplicateCardMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Card
 */
export const deleteClassroomScreenCard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/teaching_board/cards/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteClassroomScreenCardMutationKey = () => ['deleteClassroomScreenCard'] as const;

export const getDeleteClassroomScreenCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,DeleteClassroomScreenCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,DeleteClassroomScreenCardMutationVariables, TContext> => {

const mutationKey = getDeleteClassroomScreenCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, DeleteClassroomScreenCardMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreenCard(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreenCard>>>

    export type DeleteClassroomScreenCardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteClassroomScreenCardMutationVariables = {id: string}

    /**
 * @summary Delete Card
 */
export const useDeleteClassroomScreenCard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,DeleteClassroomScreenCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreenCard>>,
        TError,
        DeleteClassroomScreenCardMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteClassroomScreenCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Card Details
 */
export const getClassroomScreenCard = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ClassroomScreenCard>(
      {url: `/teaching_board/cards/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetClassroomScreenCardQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'teaching_board','cards',id
    ] as const;
    }


export const getGetClassroomScreenCardQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreenCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenCardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreenCard>>> = ({ signal }) => getClassroomScreenCard(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData>
}

export type GetClassroomScreenCardQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreenCard>>>
export type GetClassroomScreenCardQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Card Details
 */

export function useGetClassroomScreenCard<TData = Awaited<ReturnType<typeof getClassroomScreenCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClassroomScreenCardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Card
 */
export const updateClassroomScreenCard = (
    id: MaybeRefOrGetter<string>,
    classroomScreenCardInput: MaybeRefOrGetter<ClassroomScreenCardInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
classroomScreenCardInput = toValue(classroomScreenCardInput);

      return axiosClient<ClassroomScreenCard>(
      {url: `/teaching_board/cards/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenCardInput, signal
    },
      );
    }




export const getUpdateClassroomScreenCardMutationKey = () => ['updateClassroomScreenCard'] as const;

export const getUpdateClassroomScreenCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,UpdateClassroomScreenCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,UpdateClassroomScreenCardMutationVariables, TContext> => {

const mutationKey = getUpdateClassroomScreenCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreenCard>>, UpdateClassroomScreenCardMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateClassroomScreenCard(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreenCard>>>
    export type UpdateClassroomScreenCardMutationBody = ClassroomScreenCardInput
    export type UpdateClassroomScreenCardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateClassroomScreenCardMutationVariables = {id: string;data: ClassroomScreenCardInput}

    /**
 * @summary Update Card
 */
export const useUpdateClassroomScreenCard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,UpdateClassroomScreenCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreenCard>>,
        TError,
        UpdateClassroomScreenCardMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateClassroomScreenCardMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Page
 */
export const deleteClassroomScreenPage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/teaching_board/pages/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteClassroomScreenPageMutationKey = () => ['deleteClassroomScreenPage'] as const;

export const getDeleteClassroomScreenPageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,DeleteClassroomScreenPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,DeleteClassroomScreenPageMutationVariables, TContext> => {

const mutationKey = getDeleteClassroomScreenPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, DeleteClassroomScreenPageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreenPage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreenPage>>>

    export type DeleteClassroomScreenPageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteClassroomScreenPageMutationVariables = {id: string}

    /**
 * @summary Delete Page
 */
export const useDeleteClassroomScreenPage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,DeleteClassroomScreenPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreenPage>>,
        TError,
        DeleteClassroomScreenPageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteClassroomScreenPageMutationOptions(options), queryClient);
    }
    /**
 * @summary Page Details
 */
export const getClassroomScreenPage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ClassroomScreenPage>(
      {url: `/teaching_board/pages/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetClassroomScreenPageQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'teaching_board','pages',id
    ] as const;
    }


export const getGetClassroomScreenPageQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreenPage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenPageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreenPage>>> = ({ signal }) => getClassroomScreenPage(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData>
}

export type GetClassroomScreenPageQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreenPage>>>
export type GetClassroomScreenPageQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Page Details
 */

export function useGetClassroomScreenPage<TData = Awaited<ReturnType<typeof getClassroomScreenPage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClassroomScreenPageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Page
 */
export const updateClassroomScreenPage = (
    id: MaybeRefOrGetter<string>,
    classroomScreenPageInput: MaybeRefOrGetter<ClassroomScreenPageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
classroomScreenPageInput = toValue(classroomScreenPageInput);

      return axiosClient<ClassroomScreenPage>(
      {url: `/teaching_board/pages/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenPageInput, signal
    },
      );
    }




export const getUpdateClassroomScreenPageMutationKey = () => ['updateClassroomScreenPage'] as const;

export const getUpdateClassroomScreenPageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,UpdateClassroomScreenPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,UpdateClassroomScreenPageMutationVariables, TContext> => {

const mutationKey = getUpdateClassroomScreenPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreenPage>>, UpdateClassroomScreenPageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateClassroomScreenPage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreenPage>>>
    export type UpdateClassroomScreenPageMutationBody = ClassroomScreenPageInput
    export type UpdateClassroomScreenPageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateClassroomScreenPageMutationVariables = {id: string;data: ClassroomScreenPageInput}

    /**
 * @summary Update Page
 */
export const useUpdateClassroomScreenPage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,UpdateClassroomScreenPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreenPage>>,
        TError,
        UpdateClassroomScreenPageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateClassroomScreenPageMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Card
 */
export const createClassroomScreenCard = (
    pageId: MaybeRefOrGetter<string>,
    classroomScreenCardInput: MaybeRefOrGetter<ClassroomScreenCardInput>,
 signal?: AbortSignal
) => {
      pageId = toValue(pageId);
classroomScreenCardInput = toValue(classroomScreenCardInput);

      return axiosClient<ClassroomScreenCard>(
      {url: `/teaching_board/pages/${pageId}/cards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenCardInput, signal
    },
      );
    }




export const getCreateClassroomScreenCardMutationKey = () => ['createClassroomScreenCard'] as const;

export const getCreateClassroomScreenCardMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,CreateClassroomScreenCardMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,CreateClassroomScreenCardMutationVariables, TContext> => {

const mutationKey = getCreateClassroomScreenCardMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreenCard>>, CreateClassroomScreenCardMutationVariables> = (props) => {
          const {pageId,data} = props ?? {};

          return  createClassroomScreenCard(pageId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreenCard>>>
    export type CreateClassroomScreenCardMutationBody = ClassroomScreenCardInput
    export type CreateClassroomScreenCardMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateClassroomScreenCardMutationVariables = {pageId: string;data: ClassroomScreenCardInput}

    /**
 * @summary Create Card
 */
export const useCreateClassroomScreenCard = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,CreateClassroomScreenCardMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreenCard>>,
        TError,
        CreateClassroomScreenCardMutationVariables,
        TContext
      > => {
      return useMutation(getCreateClassroomScreenCardMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Cards
 */
export const listClassroomScreenCards = (
    pageId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      pageId = toValue(pageId);

      return axiosClient<ClassroomPages>(
      {url: `/teaching_board/pages/${pageId}/cards`, method: 'GET', signal
    },
      );
    }




export const getListClassroomScreenCardsQueryKey = (pageId: MaybeRefOrGetter<string>,) => {
    return [
    'teaching_board','pages',pageId,'cards'
    ] as const;
    }


export const getListClassroomScreenCardsQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreenCards>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(pageId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreenCardsQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreenCards>>> = ({ signal }) => listClassroomScreenCards(pageId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(pageId) !== null && toValue(pageId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData>
}

export type ListClassroomScreenCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreenCards>>>
export type ListClassroomScreenCardsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Cards
 */

export function useListClassroomScreenCards<TData = Awaited<ReturnType<typeof listClassroomScreenCards>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 pageId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClassroomScreenCardsQueryOptions(pageId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Move Page
 */
export const moveClassroomScreenPage = (
    pageId: MaybeRefOrGetter<string>,
    classroomScreenPageInput: MaybeRefOrGetter<ClassroomScreenPageInput>,
 signal?: AbortSignal
) => {
      pageId = toValue(pageId);
classroomScreenPageInput = toValue(classroomScreenPageInput);

      return axiosClient<ClassroomScreenPage>(
      {url: `/teaching_board/pages/${pageId}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenPageInput, signal
    },
      );
    }




export const getMoveClassroomScreenPageMutationKey = () => ['moveClassroomScreenPage'] as const;

export const getMoveClassroomScreenPageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,MoveClassroomScreenPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,MoveClassroomScreenPageMutationVariables, TContext> => {

const mutationKey = getMoveClassroomScreenPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveClassroomScreenPage>>, MoveClassroomScreenPageMutationVariables> = (props) => {
          const {pageId,data} = props ?? {};

          return  moveClassroomScreenPage(pageId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof moveClassroomScreenPage>>>
    export type MoveClassroomScreenPageMutationBody = ClassroomScreenPageInput
    export type MoveClassroomScreenPageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MoveClassroomScreenPageMutationVariables = {pageId: string;data: ClassroomScreenPageInput}

    /**
 * @summary Move Page
 */
export const useMoveClassroomScreenPage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,MoveClassroomScreenPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveClassroomScreenPage>>,
        TError,
        MoveClassroomScreenPageMutationVariables,
        TContext
      > => {
      return useMutation(getMoveClassroomScreenPageMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Screen
 */
export const createClassroomScreen = (

 signal?: AbortSignal
) => {


      return axiosClient<ClassroomScreenScreen>(
      {url: `/teaching_board/screens`, method: 'POST', signal
    },
      );
    }




export const getCreateClassroomScreenMutationKey = () => ['createClassroomScreen'] as const;

export const getCreateClassroomScreenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext> => {

const mutationKey = getCreateClassroomScreenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreen>>, void> = () => {


          return  createClassroomScreen()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreen>>>

    export type CreateClassroomScreenMutationError = ErrorType<void>


    /**
 * @summary Create Screen
 */
export const useCreateClassroomScreen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreen>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateClassroomScreenMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Screens
 */
export const listClassroomScreens = (
    params?: MaybeRefOrGetter<ListClassroomScreensParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedClassroomScreens>(
      {url: `/teaching_board/screens`, method: 'GET',
        params, signal
    },
      );
    }




export const getListClassroomScreensQueryKey = (params?: MaybeRefOrGetter<ListClassroomScreensParams>,) => {
    return [
    'teaching_board','screens', ...(params ? [params] : [])
    ] as const;
    }


export const getListClassroomScreensQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreens>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListClassroomScreensParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreensQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreens>>> = ({ signal }) => listClassroomScreens(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData>
}

export type ListClassroomScreensQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreens>>>
export type ListClassroomScreensQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Screens
 */

export function useListClassroomScreens<TData = Awaited<ReturnType<typeof listClassroomScreens>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListClassroomScreensParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClassroomScreensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Screen
 */
export const deleteClassroomScreen = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/teaching_board/screens/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteClassroomScreenMutationKey = () => ['deleteClassroomScreen'] as const;

export const getDeleteClassroomScreenMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,DeleteClassroomScreenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,DeleteClassroomScreenMutationVariables, TContext> => {

const mutationKey = getDeleteClassroomScreenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreen>>, DeleteClassroomScreenMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreen(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreen>>>

    export type DeleteClassroomScreenMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteClassroomScreenMutationVariables = {id: string}

    /**
 * @summary Delete Screen
 */
export const useDeleteClassroomScreen = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,DeleteClassroomScreenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreen>>,
        TError,
        DeleteClassroomScreenMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteClassroomScreenMutationOptions(options), queryClient);
    }
    /**
 * @summary Screen Details
 */
export const getClassroomScreen = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetClassroomScreenParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<ClassroomScreenScreen>(
      {url: `/teaching_board/screens/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetClassroomScreenQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetClassroomScreenParams>,) => {
    return [
    'teaching_board','screens',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClassroomScreenQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreen>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetClassroomScreenParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreen>>> = ({ signal }) => getClassroomScreen(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData>
}

export type GetClassroomScreenQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreen>>>
export type GetClassroomScreenQueryError = ErrorType<void>


/**
 * @summary Screen Details
 */

export function useGetClassroomScreen<TData = Awaited<ReturnType<typeof getClassroomScreen>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetClassroomScreenParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClassroomScreenQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Screen
 */
export const updateClassroomScreen = (
    id: MaybeRefOrGetter<string>,
    classroomScreenInput: MaybeRefOrGetter<ClassroomScreenInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
classroomScreenInput = toValue(classroomScreenInput);

      return axiosClient<ClassroomScreenScreen>(
      {url: `/teaching_board/screens/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenInput, signal
    },
      );
    }




export const getUpdateClassroomScreenMutationKey = () => ['updateClassroomScreen'] as const;

export const getUpdateClassroomScreenMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,UpdateClassroomScreenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,UpdateClassroomScreenMutationVariables, TContext> => {

const mutationKey = getUpdateClassroomScreenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreen>>, UpdateClassroomScreenMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateClassroomScreen(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreen>>>
    export type UpdateClassroomScreenMutationBody = ClassroomScreenInput
    export type UpdateClassroomScreenMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateClassroomScreenMutationVariables = {id: string;data: ClassroomScreenInput}

    /**
 * @summary Update Screen
 */
export const useUpdateClassroomScreen = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,UpdateClassroomScreenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreen>>,
        TError,
        UpdateClassroomScreenMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateClassroomScreenMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Page
 */
export const createClassroomScreenPage = (
    screenId: MaybeRefOrGetter<string>,
    classroomScreenPageInput: MaybeRefOrGetter<ClassroomScreenPageInput>,
 signal?: AbortSignal
) => {
      screenId = toValue(screenId);
classroomScreenPageInput = toValue(classroomScreenPageInput);

      return axiosClient<ClassroomScreenPage>(
      {url: `/teaching_board/screens/${screenId}/pages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: classroomScreenPageInput, signal
    },
      );
    }




export const getCreateClassroomScreenPageMutationKey = () => ['createClassroomScreenPage'] as const;

export const getCreateClassroomScreenPageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,CreateClassroomScreenPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,CreateClassroomScreenPageMutationVariables, TContext> => {

const mutationKey = getCreateClassroomScreenPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreenPage>>, CreateClassroomScreenPageMutationVariables> = (props) => {
          const {screenId,data} = props ?? {};

          return  createClassroomScreenPage(screenId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreenPage>>>
    export type CreateClassroomScreenPageMutationBody = ClassroomScreenPageInput
    export type CreateClassroomScreenPageMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateClassroomScreenPageMutationVariables = {screenId: string;data: ClassroomScreenPageInput}

    /**
 * @summary Create Page
 */
export const useCreateClassroomScreenPage = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,CreateClassroomScreenPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreenPage>>,
        TError,
        CreateClassroomScreenPageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateClassroomScreenPageMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Pages
 */
export const listClassroomScreenPages = (
    screenId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      screenId = toValue(screenId);

      return axiosClient<ClassroomPages>(
      {url: `/teaching_board/screens/${screenId}/pages`, method: 'GET', signal
    },
      );
    }




export const getListClassroomScreenPagesQueryKey = (screenId: MaybeRefOrGetter<string>,) => {
    return [
    'teaching_board','screens',screenId,'pages'
    ] as const;
    }


export const getListClassroomScreenPagesQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreenPages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(screenId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreenPagesQueryKey(screenId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreenPages>>> = ({ signal }) => listClassroomScreenPages(screenId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(screenId) !== null && toValue(screenId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData>
}

export type ListClassroomScreenPagesQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreenPages>>>
export type ListClassroomScreenPagesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Pages
 */

export function useListClassroomScreenPages<TData = Awaited<ReturnType<typeof listClassroomScreenPages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 screenId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClassroomScreenPagesQueryOptions(screenId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






